<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row p-3">
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label>{{ $t('common_words.farm') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              size="large"
              v-model="model.farm_id"
              v-bind:collapse-tags="true"
              :placeholder="`${$t('common_words.select')}...`"
              class="select-primary custom-width-select required-farm shadow-sm"
              @change="getLotByFarm()"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label>{{ $t('common_words.allotment') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              size="large"
              v-model="model.lot_id"
              v-bind:collapse-tags="true"
              :placeholder="`${$t('common_words.select')}...`"
              class="select-primary custom-width-select required-lot shadow-sm"
              @change="closeCard()"
            >
              <el-option
                v-for="(option, index) in lots"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-3 col-xl-3 mb-3">
            <label>{{ $t('common_words.date') }}: *</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              type="date"
              range-separator="-"
              v-model="model.date"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              class="shadow-sm date-form required-date"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-xl-3">
            <br class="mb-1" />
            <button
              class="btn btn-success custom-shadow-btn btn-filter"
              @click="validate"
            >
              {{ $t('common_words.generate') }}
            </button>
          </div>
        </div>
      </card>
      <div v-if="isIndex()">
        <div v-if="canShow">
          <card
            class="custom-shadow-card-header custom-table-responsive"
            :title="$t('sigatoka.sigatoka_capture')"
          >
            <div class="row p-3">
              <el-tabs
                class="w-100"
                v-model="activeName"
                @tab-click="handleClick"
              >
                <el-tab-pane
                  v-for="item in model.ages"
                  :key="item.id"
                  :label="ageLabel(item.age)"
                  :name="String(item.id)"
                >
                  <age-table
                    :age="item.age"
                    :changeLabel="model.changeLabel == 0 ? false : true"
                    :infectionPicture="
                      model.infectionPicture == 0 ? false : true
                    "
                    :ref="`ageTable_${item.id}`"
                  />
                </el-tab-pane>
                <el-tab-pane
                  v-if="model.hasYoungPlants"
                  :label="$t('sigatoka.young_plants')"
                  name="young_plants"
                >
                  <young-table :leaves="model.leaves" ref="youngTable" />
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="row">
              <div
                v-if="isCreate() || isUpdate()"
                :class="hasData ? 'col-6 text-right' : 'col-12 text-center'"
              >
                <l-button
                  wide
                  type="info"
                  class="btn-filter m-4"
                  @click="saveData"
                >
                  {{ $t('common_words.save') }}
                </l-button>
              </div>
              <div class="col-6 text-left" v-if="isDelete() && hasData">
                <l-button
                  wide
                  type="danger"
                  class="btn-filter m-4"
                  @click="deleteCapture()"
                >
                  {{ $t('common_words.delete') }}
                </l-button>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from 'src/i18n';
import { isset } from 'src/util/Util';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import MixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import AgesTable from 'src/views/Pages/Dashboard/Sigatoka/SigatokaCapture/AgesTable.vue';
import YoungsTable from 'src/views/Pages/Dashboard/Sigatoka/SigatokaCapture/YoungsTable.vue';

export default {
  mixins: [MixinMasters, MixinPermissions, MixinForm, MixinMenu],
  components: {
    [AgesTable.name]: AgesTable,
    [YoungsTable.name]: YoungsTable,
  },
  watch: {
    '$i18n.locale': 'forceRerender',
  },
  data() {
    return {
      model: {
        id: null,
        ages: [],
        leaves: [],
        date: null,
        lot_id: null,
        farm_id: null,
        hasYoungPlants: false,
        changeLabel: false,
        infectionPicture: false,
        sigatoka_config_id: null,
      },
      lots: [],
      farms: [],
      canShow: false,
      hasData: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      activeName: '',
    };
  },
  computed: {
    getModuleRoute() {
      return 'sigatoka/capture';
    },
  },
  methods: {
    handleClick() {},
    closeCard() {
      this.canShow = false;
    },
    async validate() {
      if (!isset(this.model.farm_id))
        return this.validationInputsRequired('farm');
      if (!isset(this.model.lot_id))
        return this.validationInputsRequired('lot');
      if (!isset(this.model.date)) return this.validationInputsRequired('date');
      const hasConfig = await this.hasConfig();
      if (!hasConfig) {
        this.canShow = false;
        return SweetAlert.warning(i18n.t('common_words.no_associated_config'));
      }
      this.canShow = true;
      await this.$nextTick();
      const response = await this.getCapture();
      const capture =
        response && response.data && response.data.data
          ? response.data.data
          : null;
      if (capture) {
        this.hasData = true;
        this.setCaptureData(capture);
      }
    },
    prepareCaptureData(data) {
      const agePlants = this.prepareAgePlants(data.age_plants);
      const youngPlants = this.prepareYoungPlants(data.young_plants);
      const invalidAge = agePlants.find((ageGroup) => {
        const activePlants = ageGroup.plants.filter((plant) => !plant.deleted);

        return activePlants.length === 0;
      });
      if (invalidAge) {
        return {
          valid: false,
          message: i18n.t('sigatoka.must_have_at_least_one_register'),
        };
      }
      if (this.model.hasYoungPlants) {
        const activeYoungPlants = youngPlants.filter((plant) => !plant.deleted);
        if (activeYoungPlants.length === 0) {
          return {
            valid: false,
            message: i18n.t('sigatoka.must_have_at_least_one_register'),
          };
        }
      }
      return {
        valid: true,
        data: {
          age_plants: agePlants,
          young_plants: youngPlants,
        },
      };
    },
    prepareAgePlants(ageGroups) {
      return ageGroups.map((ageGroup) => {
        const plants = ageGroup.plants
          .filter(
            (plant) =>
              (plant.id && plant.deleted) ||
              this.hasAgePlantData(plant, ageGroup.age)
          )
          .map((plant) => {
            const normalizedPlant = {
              ...plant,
            };
            if (ageGroup.age !== 0 && ageGroup.age !== 6)
              normalizedPlant.yli = null;
            if (this.model.infectionPicture)
              normalizedPlant.grades = {
                0: this.toNumberOrZero(plant.grades[0]),
                1: this.toNumberOrZero(plant.grades[1]),
                2: this.toNumberOrZero(plant.grades[2]),
                3: this.toNumberOrZero(plant.grades[3]),
                4: this.toNumberOrZero(plant.grades[4]),
              };

            return normalizedPlant;
          });

        return {
          ...ageGroup,
          plants,
        };
      });
    },
    prepareYoungPlants(plants) {
      if (!this.model.hasYoungPlants) return [];

      return plants
        .filter(
          (plant) =>
            (plant.id && plant.deleted) || this.hasYoungPlantData(plant)
        )
        .map((plant) => ({
          ...plant,

          leaf_values: Object.keys(plant.leaf_values || {}).reduce(
            (result, leaf) => {
              result[leaf] = this.toNumberOrZero(plant.leaf_values[leaf]);

              return result;
            },
            {}
          ),
        }));
    },
    hasAgePlantData(plant, age) {
      const hasHt = this.hasValue(plant.total_leaves);
      const hasYls = this.hasValue(plant.yls);
      const hasYli = (age === 0 || age === 6) && this.hasValue(plant.yli);
      const hasGrades =
        this.model.infectionPicture &&
        plant.grades &&
        [
          plant.grades[1],
          plant.grades[2],
          plant.grades[3],
          plant.grades[4],
        ].some((value) => this.hasValue(value));

      return hasHt || hasYls || hasYli || hasGrades;
    },
    hasYoungPlantData(plant) {
      const hasBasicData =
        this.hasValue(plant.total_leaves) || this.hasValue(plant.ref);
      const hasLeafData =
        plant.leaf_values &&
        Object.values(plant.leaf_values).some((value) => this.hasValue(value));

      return hasBasicData || hasLeafData;
    },
    hasValue(value) {
      return value !== null && value !== undefined && value !== '';
    },
    async hasConfig() {
      this.showHideLoading(true);
      this.model.route = 'sigatoka/capture/config';
      const configRes = await Axios.postMasters(this.model);
      if (!configRes || !configRes.data.data) {
        this.showHideLoading(false);
        return false;
      }
      const config = configRes.data.data;
      this.model.ages = config.sigatoka_config_ages.map((item) => ({
        id: item.id,
        age: item.age,
      }));
      this.model.leaves = config.sigatoka_config_leaves.map(
        (item) => item.leaf
      );
      this.model.hasYoungPlants = config.young_plant;
      this.model.sigatoka_config_id = config.id;
      this.model.changeLabel = config.change_label;
      this.model.infectionPicture = config.infection_picture;
      if (this.model.ages.length > 0)
        this.activeName = String(this.model.ages[0].id);
      this.showHideLoading(false);

      return true;
    },
    deleteCapture() {
      this.showHideLoading(true);
      if (this.isDelete() && !this.model.isCreate) {
        SweetAlert.delete(
          this.$t('common_words.confirm'),
          this.$t('sigatoka.confirm_capture_delete')
        ).then(async (result) => {
          if (result.value) {
            this.model.route = 'sigatoka/capture';
            await Axios.destroyMaster(this.model).then((response) => {
              this.showHideLoading(false);
              this.alertResponse(response);
            });
          }
        });
      }
      this.showHideLoading(false);
    },
    getLotByFarm() {
      if (!isset(this.model.farm_id)) return;
      this.lots = [];
      this.canShow = false;
      this.model.lot_id = null;
      this.farms.forEach((element) => {
        if (this.model.farm_id == element.id) {
          element.lots.forEach((item) => {
            this.lots.push(item);
          });
        }
      });
    },
    async getCapture() {
      this.hasData = false;
      const data = {
        route: 'sigatoka/capture/getcapture',
        farm_id: this.model.farm_id,
        lot_id: this.model.lot_id,
        date: this.model.date,
      };

      return await Axios.postMasters(data);
    },
    getCaptureData() {
      const agePlants = this.model.ages.map((age) => {
        const ref = this.$refs[`ageTable_${age.id}`];
        const component = Array.isArray(ref) ? ref[0] : ref;
        return {
          age_id: age.id,
          age: age.age,
          plants: component ? component.getData() : [],
        };
      });
      let youngPlants = [];
      if (this.model.hasYoungPlants && this.$refs.youngTable) {
        const ref = this.$refs.youngTable;
        const component = Array.isArray(ref) ? ref[0] : ref;
        youngPlants = component ? component.getData() : [];
      }

      return {
        age_plants: agePlants,
        young_plants: youngPlants,
      };
    },
    setCaptureData(capture) {
      this.model.id = capture.id;
      this.setCaptureAges(capture);
      this.setCaptureYoung(capture);
    },
    setCaptureAges(capture) {
      const capturedPlants = capture.sigatoka_age_plants || [];
      this.model.ages.forEach((ageConfig) => {
        const ref = this.$refs[`ageTable_${ageConfig.id}`];
        const component = Array.isArray(ref) ? ref[0] : ref;
        if (!component) return;
        const plants = capturedPlants.filter(
          (plant) => Number(plant.age) === Number(ageConfig.age)
        );
        component.setData(plants);
      });
    },
    setCaptureYoung(capture) {
      if (!this.model.hasYoungPlants) return;
      const ref = this.$refs.youngTable;
      const component = Array.isArray(ref) ? ref[0] : ref;
      if (!component) return;
      component.setData(capture.sigatoka_young_plants || []);
    },
    ageLabel(age) {
      if (age == 0) return i18n.t('sigatoka.expecting');
      if (age === 1) return i18n.t('sigatoka.newly_given_birth');
      if (age === 6 && this.model.changeLabel)
        return i18n.t('sigatoka.young_6_weeks');

      return `${age} ${i18n.t('common_words.weeks')}`;
    },
    toNumberOrZero(value) {
      if (value === null || value === undefined || value === '') return 0;
      return Number(value);
    },
    saveData() {
      const data = this.getCaptureData();
      const validation = this.prepareCaptureData(data);
      if (!validation.valid) return SweetAlert.warning(validation.message);
      const payload = {
        id: this.model.id,
        farm_id: this.model.farm_id,
        lot_id: this.model.lot_id,
        date: this.model.date,
        sigatoka_config_id: this.model.sigatoka_config_id,
        hasYoungPlants: this.model.hasYoungPlants,
        changeLabel: this.model.changeLabel,
        infectionPicture: this.model.infectionPicture,
        data: validation.data,
      };
      this.showHideLoading(true);
      payload.route = this.getModuleRoute;
      if (this.hasData) {
        if (this.isUpdate()) {
          Axios.updateMaster(payload)
            .then((response) => {
              this.showHideLoading();
              this.alertResponse(response);
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(payload)
            .then((response) => {
              this.showHideLoading();
              this.alertResponse(response);
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
    alertResponse(response) {
      SweetAlert.success(
        response.data.message ? response.data.message : response.errors
      ).then((result) => {
        if (result) {
          this.showHideLoading();
          this.cleanData();
          this.canShow = false;
        }

        return result;
      });
    },
    cleanData() {
      this.model.id = null;
      this.model.farm_id = null;
      this.model.lot_id = null;
      this.model.date = null;
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([Axios.getMasters('farms/farms/only')])
        .then(([responseFarm]) => {
          this.farms = responseFarm.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },
  mounted() {
    this.selectedItemOnMenu('sigatoka');
  },
};
</script>
